import React, { useMemo } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const RichTextEditor = ({ 
  value, 
  onChange, 
  placeholder = "Enter description...",
  minHeight = "150px"
}) => {
  const modules = useMemo(() => ({
    toolbar: [
      [{ 'header': [1, 2, 3, false] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],
      [{ 'color': [] }, { 'background': [] }],
      ['link'],
      ['clean']
    ],
  }), []);

  const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet', 'indent',
    'color', 'background',
    'link'
  ];

  return (
    <div className="rich-text-editor">
      <style>{`
        .rich-text-editor .ql-container {
          min-height: ${minHeight};
          font-size: 14px;
          border-radius: 0 0 8px 8px;
          border-color: var(--border-color);
          background: var(--bg-primary);
        }
        .rich-text-editor .ql-toolbar {
          border-radius: 8px 8px 0 0;
          border-color: var(--border-color);
          background: var(--bg-secondary);
        }
        .rich-text-editor .ql-editor {
          min-height: ${minHeight};
          color: var(--text-primary);
        }
        .rich-text-editor .ql-editor.ql-blank::before {
          color: var(--text-tertiary);
          font-style: normal;
        }
        .rich-text-editor .ql-snow .ql-stroke {
          stroke: var(--text-secondary);
        }
        .rich-text-editor .ql-snow .ql-fill {
          fill: var(--text-secondary);
        }
        .rich-text-editor .ql-snow .ql-picker {
          color: var(--text-secondary);
        }
        .rich-text-editor .ql-snow .ql-picker-options {
          background: var(--bg-primary);
          border-color: var(--border-color);
        }
        .rich-text-editor .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {
          border-color: var(--border-color);
        }
        .rich-text-editor .ql-snow.ql-toolbar button:hover,
        .rich-text-editor .ql-snow .ql-toolbar button:hover {
          color: var(--primary-color);
        }
        .rich-text-editor .ql-snow.ql-toolbar button:hover .ql-stroke,
        .rich-text-editor .ql-snow .ql-toolbar button:hover .ql-stroke {
          stroke: var(--primary-color);
        }
        .rich-text-editor .ql-snow.ql-toolbar button.ql-active,
        .rich-text-editor .ql-snow .ql-toolbar button.ql-active {
          color: var(--primary-color);
        }
        .rich-text-editor .ql-snow.ql-toolbar button.ql-active .ql-stroke,
        .rich-text-editor .ql-snow .ql-toolbar button.ql-active .ql-stroke {
          stroke: var(--primary-color);
        }
      `}</style>
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
      />
    </div>
  );
};

export default RichTextEditor;
